module.exports = __webpack_public_path__ + "img/armhole length front.3c87e0dd.png";